ACC.forgottenpassword = {

	_autoload: [
		"bindLink"
	],

	minDesktopWidth: 1024,

	bindLink: function(){

		$(document).on("click",".js-password-forgotten",function(e){
			e.preventDefault();

			var titre = $(this).data("cboxTitle"),
					titreOK = $(this).data("cboxTitle2"),
					titreKO = $(this).data("cboxTitle1");

			if($(window).width() > ACC.forgottenpassword.minDesktopWidth) {
				ACC.colorbox.open(titre, {
						href: $(this).data("link"),
						width:"500px",
						fixed: true,
						top: 200,
						class: 'fff',
						onOpen: function() {
							$('#validEmail').remove();
						},
						onComplete: function() {
							$('form#forgottenPwdForm').ajaxForm({
								success: function(data) {
									if ($(data).closest('#validEmail').length) {

										if($(data).closest("div.alert").hasClass("positive")) {
											titre = titreOK;
										} else {
											titre = titreKO;
										}

										$(".forgotten-password-popin .description").html($(data).closest('.forgotten-password'));

									} else {
										titre = titreKO;
										$(".forgotten-password-popin .description").replaceWith($(data).find('.description'));
									}

									$("#cboxTitle .headline .headline-text").html(titre);
									$("#forgottenPwdForm .control-group").replaceWith($(data).find('.control-group'));
 								  $("#forgottenPwdForm .form-control").val('');
									ACC.colorbox.resize();
								}
							});
						}
					}
				);
			} else {

				var headerContent = '<div class="headline"><span class="headline-text">'+titre+'</span></div>';

				$(document).on("submit","#forgottenPwdForm",function(event) {
					event.preventDefault();
					var form = $("form#forgottenPwdForm");

					$.ajax({
						url: form.attr('action'),
						type: "POST",
						data: form.serialize(),
						success: function(result) {

							if ($(result).closest('#validEmail').length) {

								if($(result).closest("div.alert").hasClass("positive")) {
									titre = titreOK;
								} else {
									titre = titreKO;
								}

								$(".forgotten-password-popin .description").html($(result).closest('.forgotten-password'));

							} else {
								titre = titreKO;
								$(".forgotten-password-popin .description").replaceWith($(result).find('.description'));
							}

							$(".loginPage .headline .headline-text").html(titre);
							$(".forgotten-password-popin .control-group").replaceWith($(result).find('.control-group'));
							$("#forgottenPwdForm .form-control").val('');

							$("html, body").animate({ scrollTop: 0 }, "slow");
						}
					});
					return false;
				});

				$.ajax({
					url: $(this).data("link"),
					type: 'POST',
					success : function(data, statut) {
						$(".loginPage").html(headerContent+data);
						$(".loginPage").addClass("pwd");
						$("html, body").animate({ scrollTop: 0 }, "slow");
					},
					error : function(resultat, statut, erreur) {
					},
					complete : function(resultat, statut) {
						$('.form-group').removeClass("has-error");
						var err = document.getElementById("email.errors");
						err.innerHTML = "";
					}
		    });
			}
		});
	}

};
